import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VisitorDashboardComponent } from './visitor-dashboard/visitor-dashboard.component';
import { VisitorComponent } from './visitor/visitor.component';
import { InductionTrainingPaperComponent } from './induction-training-paper/induction-training-paper.component';
import { AfterPreRequestVisitorComponent } from './after-pre-request-visitor/after-pre-request-visitor.component';
import { AuthGuard } from '../auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'visitor-dashboard',
    pathMatch: 'full'
  },
  {
    path: 'visitor',
    component: VisitorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'visitor-dashboard',
    component: VisitorDashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'after-pre-request/:id',
    component: AfterPreRequestVisitorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'induction-training-paper',
    component: InductionTrainingPaperComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VisitorManagementRoutingModule { }
